var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7879 3.59274C14.7879 3.11046 14.3969 2.7195 13.9146 2.7195H6.49208C3.3211 2.7195 0.816013 5.39549 0.816013 8.61387C0.816013 11.8323 3.3211 14.5083 6.49208 14.5083H9.48178C9.75792 14.5083 9.98178 14.2844 9.98178 14.0083V13.2618C9.98178 12.9856 9.75792 12.7618 9.48178 12.7618H6.49208C4.35801 12.7618 2.5625 10.9417 2.5625 8.61387C2.5625 6.28607 4.35801 4.46598 6.49208 4.46598H13.9146C14.3969 4.46598 14.7879 4.07502 14.7879 3.59274Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8504 0.881396C10.6551 1.07666 10.6551 1.39324 10.8504 1.5885L12.8918 3.62994L10.8504 5.67137C10.6551 5.86663 10.6551 6.18321 10.8504 6.37848L11.3782 6.90632C11.5735 7.10158 11.8901 7.10158 12.0853 6.90632L14.7442 4.24741C15.0853 3.90639 15.0853 3.35348 14.7442 3.01246L12.0853 0.353553C11.8901 0.158291 11.5735 0.158291 11.3782 0.353553L10.8504 0.881396Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.64d5ccba2a76af635a7d05792448a429.svg";
export { ForwardRef as ReactComponent };